import { render, staticRenderFns } from "./FloatingSupportIcon.vue?vue&type=template&id=5a5bb324&scoped=true&"
import script from "./FloatingSupportIcon.vue?vue&type=script&lang=ts&"
export * from "./FloatingSupportIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingSupportIcon.vue?vue&type=style&index=0&id=5a5bb324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5bb324",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
